import { AfterViewInit, Component, Inject, OnInit, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Alginment, EMPTY_STRING, LoadingMessages } from "src/app/common/Const";
import { ME200018 } from "src/app/common/const-message-id";
import { GC_D2016_CORR_SLIP } from "src/app/common/ConstCcd";
import { TableColumnDef } from "src/app/common/table-column-def";
import { ReqAccess } from "src/app/request/req-access";
import { Spmt10321DetailCommentDto } from "src/app/request/req-spmt10321-confirm";
import { ReqSpmt10321DetailSearch } from "src/app/request/req-spmt10321-search";
import { Spmt10321DetailSearchRowDto } from "src/app/response/rsp-spmt10321-search";
import { CommonService } from "src/app/service/common.service";
import { HttpBasicService } from "src/app/service/http-basic.service";
import { MessageService } from "src/app/service/message.service";

export enum ColumnIds {
  SlipLineNo = "slipLineNo",
  ProductCd = "productCd",
  StandardNm = "standardNm",
  DisposalReasonNm = "disposalReasonNm",
  DtQty = "dtQty",
  CostExc = "costExc",
  SellPriceExc = "sellPriceExc",
  SlipDtlComment = "slipDtlComment",
  SlipDtlApproverComment = "slipDtlApproverComment",
  ErrorMessage = "errorMessage",
  ProductNm = "productNm",
  CostAmtExc = "costAmtExc",
  SellPriceAmtExc = "sellPriceAmtExc",
}

export enum ColumnHeaders {
  SlipLineNo = "伝票行番号",
  ProductCd = "商品コード",
  StandardNm = "規格",
  DisposalReasonNm = "廃棄理由",
  DtQty = "数量",
  CostExc = "原単価(抜)",
  SellPriceExc = "売単価(抜)",
  SlipDtlComment = "伝票詳細コメント",
  SlipDtlApproverComment = "伝票詳細承認者コメント",
  ErrorMessage = "システムメッセージ",
  ProductNm = "商品名称",
  CostAmtExc = "原価金額(抜)",
  SellPriceAmtExc = "売価金額(抜)",
}

interface TableRow extends Spmt10321DetailSearchRowDto {
  errorMessage: string;
  form: {
    slipDtlApproverCommentFormCtrl: FormControl;
  };
}
@Component({
  selector: "spmt10321-detail-dialog",
  templateUrl: "./spmt10321-detail-dialog.component.html",
  styleUrls: ["./spmt10321-detail-dialog.component.css"],
})
export class Spmt10321DetailDialogComponent implements OnInit, AfterViewInit {
  columnIdFirst: string[] = [
    ColumnIds.SlipLineNo,
    ColumnIds.ProductCd,
    ColumnIds.StandardNm,
    ColumnIds.DisposalReasonNm,
    ColumnIds.DtQty,
    ColumnIds.CostExc,
    ColumnIds.SellPriceExc,
    ColumnIds.SlipDtlComment,
    ColumnIds.SlipDtlApproverComment,
    ColumnIds.ErrorMessage,
  ];
  columnIdSecond: string[] = [ColumnIds.ProductNm, ColumnIds.CostAmtExc, ColumnIds.SellPriceAmtExc];
  columnDefsItemsFirst: TableColumnDef[] = [
    { columnId: ColumnIds.SlipLineNo, header: ColumnHeaders.SlipLineNo, width: 70, align: Alginment.Left, rowspan: 2 },
    { columnId: ColumnIds.ProductCd, header: ColumnHeaders.ProductCd, width: 105, align: Alginment.Left, rowspan: 1 },
    { columnId: ColumnIds.StandardNm, header: ColumnHeaders.StandardNm, width: 85, align: Alginment.Left, rowspan: 1 },
    { columnId: ColumnIds.DisposalReasonNm, header: ColumnHeaders.DisposalReasonNm, width: 70, align: Alginment.Left, rowspan: 2 },
    { columnId: ColumnIds.DtQty, header: ColumnHeaders.DtQty, width: 50, align: Alginment.Right, rowspan: 2, numberPipe: "1.0-0" },
    { columnId: ColumnIds.CostExc, header: ColumnHeaders.CostExc, width: 85, align: Alginment.Right, rowspan: 1, numberPipe: "1.2-2" },
    { columnId: ColumnIds.SellPriceExc, header: ColumnHeaders.SellPriceExc, width: 85, align: Alginment.Right, rowspan: 1, numberPipe: "1.2-2" },
    { columnId: ColumnIds.SlipDtlComment, header: ColumnHeaders.SlipDtlComment, width: 160, align: Alginment.Left, rowspan: 2 },
    { columnId: ColumnIds.SlipDtlApproverComment, header: ColumnHeaders.SlipDtlApproverComment, width: 160, align: Alginment.Left, rowspan: 2, isTextbox: true },
    { columnId: ColumnIds.ErrorMessage, header: ColumnHeaders.ErrorMessage, width: 160, align: Alginment.Left, rowspan: 2, class: "error-message" },
  ];

  columnDefsItemsSecond: TableColumnDef[] = [
    { columnId: ColumnIds.ProductNm, header: ColumnHeaders.ProductNm, width: 190, align: Alginment.Left, rowspan: 1, colspan: 2 },
    { columnId: ColumnIds.CostAmtExc, header: ColumnHeaders.CostAmtExc, width: 75, align: Alginment.Right, rowspan: 1, numberPipe: "1.0-0" },
    { columnId: ColumnIds.SellPriceAmtExc, header: ColumnHeaders.SellPriceAmtExc, width: 75, align: Alginment.Right, rowspan: 1, numberPipe: "1.0-0" },
  ];

  dataSource: MatTableDataSource<TableRow> = new MatTableDataSource<TableRow>([]);
  itemTableWidth: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  constructor(
    private readonly dialogRef: MatDialogRef<Spmt10321DetailDialogComponent>,
    private readonly httpBasic: HttpBasicService,
    private readonly messages: MessageService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      access: ReqAccess;
      isDisableRow: boolean;
      storeCd: string;
      systemSlipNo: string;
      slipNo: string;
      updDateTime: string;
      details: Spmt10321DetailCommentDto[];
      redBlackFlg: string;
    },
    public commonService: CommonService
  ) {}
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  get GC_D2016_CORR_SLIP() {
    return GC_D2016_CORR_SLIP;
  }

  private fnSearch() {
    const req: ReqSpmt10321DetailSearch = {
      access: this.data.access,
      systemSlipNo: this.data.systemSlipNo,
      updDateTime: this.data.updDateTime,
      disableRow: this.data.isDisableRow,
      storeCd: this.data.storeCd,
    };
    this.httpBasic.beforeRequestStart(LoadingMessages.Searching);
    this.httpBasic.spmt10321DetailSearch(req).subscribe({
      next: (res) => {
        if (this.httpBasic.handleAppError(res)) return;
        this.dataSource.data = res.rows.map((item) => ({
          ...item,
          errorMessage: item.outOfStockFlg ? this.messages.message[ME200018].replace("%1", "数量") : EMPTY_STRING,
          form: {
            slipDtlApproverCommentFormCtrl: new FormControl({
              value: this.data.details.find((detail) => detail.systemSlipDetailNo === item.systemSlipDetailNo)?.slipDtlApproverComment || item.slipDtlApproverComment,
              disabled: this.data.isDisableRow,
            }),
          },
        }));
      },
      error: (err) => {
        this.httpBasic.afterRequestError(err);
      },
      complete: () => {
        this.httpBasic.afterRequestComplete();
      },
    });
  }

  ngOnInit() {
    this.calcTableWidth();
    this.fnSearch();
  }

  calcTableWidth() {
    this.itemTableWidth = { width: "100%" };
  }

  btnConfirmClick(): void {
    const result = this.dataSource.data.map((item) => {
      return {
        systemSlipDetailNo: item.systemSlipDetailNo,
        slipDtlApproverComment: item.form.slipDtlApproverCommentFormCtrl.value,
      };
    });

    this.dialogRef.close(result);
  }
}
